import React from "react";

function DashboardCards({ dashboard }) {
  return (
    <div className="row g-4">
      <div className="col-md-3">
        <div className="card dashboard-card stat-card">
          <h6>Current Day</h6>
          <h2>
            {dashboard?.current_day || 0}/
            {dashboard?.total_days || 60}
          </h2>
        </div>
      </div>

      <div className="col-md-3">
        <div className="card dashboard-card stat-card">
          <h6>Health Score</h6>
          <h2>{dashboard?.health_score || 0}%</h2>
        </div>
      </div>

      <div className="col-md-3">
        <div className="card dashboard-card stat-card">
          <h6>Total Photos</h6>
          <h2>{dashboard?.total_photos || 0}</h2>
        </div>
      </div>

      <div className="col-md-3">
        <div className="card dashboard-card stat-card">
          <h6>Pending Tasks</h6>
          <h2>{dashboard?.pending_tasks || 0}</h2>
        </div>
      </div>
    </div>
  );
}

export default DashboardCards;